import { useExportDataFunction } from 'src/components/BeaconV2Components/common/AppExportModal/exportDataHooks';

export const useLegacyExportLive = () => {
  const req = useExportDataFunction({
    type: 'Current',
    groupByFieldName: 'stacklineSku',
    includeCompTimePeriod: false
  });

  return req.exportRequestFunction;
};
